import { render } from "./Studies.vue?vue&type=template&id=3c1397d9"
import script from "./Studies.vue?vue&type=script&lang=js"
export * from "./Studies.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__